import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { ABILITIES } from "@/lib/abilities";
import { useTaal } from "@/contexts/TaalContext";

/** De vier abilities, in het Engels onder hun gbrain-naam, met waar je ze vindt. Post d, 3ax-10. */
export default function AbilitiesLijst() {
  const { t } = useTaal();
  const navigate = useNavigate();
  return (
    <section className="mb-6 space-y-2" data-testid="abilities">
      <h2 className="text-sm font-medium">{t("Wat NovaMund al kan")}</h2>
      <div className="grid gap-2 sm:grid-cols-2">
        {ABILITIES.map((a) => (
          <article key={a.naam} className="border rounded-lg p-3 space-y-1 min-w-0" data-testid="ability">
            <h3 className="text-sm font-medium">{t(a.naam)}</h3>
            <p className="text-xs text-muted-foreground">{t(a.wat)}</p>
            <p className="text-xs">{t(a.waar)}</p>
            <Button size="sm" variant="outline" className="min-h-9" onClick={() => navigate(a.pad)}>
              {t(a.knop)}
            </Button>
          </article>
        ))}
      </div>
    </section>
  );
}
